import {
  ChatWidgetText,
  InvoicesWidget,
  isSafeWidgetUrl,
} from "../../../Helper/ChatWidget";
import { DownloadIcon } from "../ChatWidgetIcons";
import { Card, LinkFoot, openWidgetUrl, Pill } from "../ChatWidgetPrimitives";
import "./InvoicesCard.scss";

/** 08 Invoices: newest first, each with its download. */
export const InvoicesCard = ({
  widget,
  text,
}: {
  widget: InvoicesWidget;
  text: ChatWidgetText;
}) => {
  const title = widget.title ?? text("widgetInvoices");
  return (
    <Card className="cw-inv" label={title}>
      <div className="cw-row cw-pad cw-inv-head">
        <span className="cw-h">{title}</span>
        {widget.subtitle && (
          <span className="cw-muted cw-sm">{widget.subtitle}</span>
        )}
      </div>
      <ul className="cw-inv-list">
        {(widget.items ?? []).map((item) => (
          <li className="cw-inv-row" key={item.id}>
            <div className="cw-stack cw-grow">
              <span className="cw-medium">{item.number}</span>
              <span className="cw-muted cw-sm cw-num">{item.date}</span>
            </div>
            <span className="cw-num cw-strong">{item.amount}</span>
            <Pill status={item.status} withDot={false} />
            {isSafeWidgetUrl(item.url) && (
              <button
                type="button"
                className="cw-inv-dl"
                aria-label={text("widgetDownload", { name: item.number })}
                onClick={() => openWidgetUrl(item.url)}
              >
                <span className="cw-inv-dl-face">
                  <DownloadIcon size={16} />
                </span>
              </button>
            )}
          </li>
        ))}
      </ul>
      <LinkFoot url={widget.url}>{text("widgetAllInvoices")}</LinkFoot>
    </Card>
  );
};
